module.exports = __webpack_public_path__ + "static/media/logo.dac4a15a.jpg";